import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';

// Audit Wave 2 / Lane 5 (M-066, H3). `getByInstitution` now resolves rows carrying
// `apiKeyPrefix` only (no plaintext field at all — see DeviceApiKeyDTO). `generate` and `rotate`
// resolve the reveal-once shape instead (`apiKey` plaintext + `apiKeyPrefix`, both present exactly
// on this one response) — DeviceApiKeyList is the only caller and narrows the type there.
export const DeviceApiKeyService = {
    getByInstitution: async () => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.get(ENDPOINTS.DEVICE_API_KEY.BY_INSTITUTION(institutionId), {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    generate: async (description: string, deviceSn: string) => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.post(
            ENDPOINTS.DEVICE_API_KEY.BY_INSTITUTION(institutionId),
            { description, deviceSn },
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    rotate: async (id: string) => {
        const response = await axios.post(
            ENDPOINTS.DEVICE_API_KEY.ROTATE(id),
            {},
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    toggleActive: async (id: string) => {
        const response = await axios.patch(
            ENDPOINTS.DEVICE_API_KEY.TOGGLE_ACTIVE(id),
            {},
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    /** S4-12: last sync per attendance machine. */
    getSyncStatus: async () => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.get(ENDPOINTS.DEVICE_API_KEY.SYNC_STATUS(institutionId), {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    /** S4-12: blank zone = the PC sends UTC (standard); a zone = the PC sends local wall time from `clockZoneFrom`. */
    setClockZone: async (id: string, clockZone: string, clockZoneFrom: string | null) => {
        const response = await axios.patch(
            ENDPOINTS.DEVICE_API_KEY.CLOCK_ZONE(id),
            { clockZone, clockZoneFrom },
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    deleteKey: async (id: string) => {
        await axios.delete(ENDPOINTS.DEVICE_API_KEY.DELETE(id), {
            headers: AuthService.getAuthHeader()
        });
    },
};
